import React from 'react';

import { Link } from 'react-router-dom';

const buttonTypes = {
  primary: 'c-btn--primary',
  secondary: 'c-btn--secondary',
  tertiary: 'c-btn--tertiary',
  nav: 'c-btn--nav',
};

const getButtonClassByType = (btnType) => {
  return buttonTypes[btnType] || 'c-btn--primary';
};

const Button = ({ to, className = '', btnType, children, onClick }) => (
  <Link
    to={to}
    className={`c-btn ${className} ${getButtonClassByType(btnType)}`}
    role="button"
    onClick={onClick}
  >
    {children}
  </Link>
);
export default Button;
